module.exports = __webpack_public_path__ + "img/frame-pic.5572da54.png";